import { type FormSection } from "@/models"
import {
	faAddressBook,
	faCircleInfo,
	faCoins,
	faFileContract,
	faFileExport,
	faGlasses,
	faIdCard,
	faSignature,
} from "@fortawesome/free-solid-svg-icons"
import AdditionalInformation from "./AdditionalInformation"
import AddressInformation from "./AddressInformation"
import ClaimantInformation from "./ClaimantInformation"
import ClaimInformation from "./ClaimInformation"
import EarningsInformation from "./EarningsInformation"
import ExportInformation from "./ExportInformation"
import PartnerInformation from "./PartnerInformation"
import SelfAssessedInformation from "./SelfAssessedInformation"
import SignatureInformation from "./SignatureInformation"

const alpha = 0.1
const green = `rgba(92, 232, 72, ${alpha})`
const blue = `rgba(72, 179, 232, ${alpha})`
const red = `rgba(204, 0, 0, ${alpha})`
const orange = `rgba(227, 164, 15, ${alpha})`
const purple = `rgba(77, 72, 232, ${alpha})`
const yellow = `rgba(255, 251, 0, ${alpha})`
const gray = `rgba(145, 145, 145, ${alpha})`
const pink = `rgba(227, 0, 192, ${alpha})`
const turquoise = `rgba(64, 224, 208, ${alpha})`

export const AllFormSections = [
	{
		id: "claim",
		name: "Claim Information",
		icon: faCircleInfo,
		color: green,
		render: ClaimInformation,
	},
	{
		id: "selfAssessed",
		name: "Self Assessed Information",
		icon: faGlasses,
		color: red,
		render: SelfAssessedInformation,
	},
	{
		id: "address",
		name: "Address Information",
		icon: faAddressBook,
		color: blue,
		render: AddressInformation,
	},
	{
		id: "claimantDetails",
		name: "Claimant Information",
		icon: faIdCard,
		color: orange,
		render: ClaimantInformation,
	},
	{
		id: "partnerDetails",
		name: "Partner Details",
		icon: faIdCard,
		color: purple,
		render: PartnerInformation,
	},
	{
		id: "earnings",
		name: "Earnings Information",
		icon: faCoins,
		color: yellow,
		render: EarningsInformation,
	},
	{
		id: "signatures",
		name: "Signature Information",
		icon: faSignature,
		color: gray,
		render: SignatureInformation,
	},
	{
		id: "additional",
		name: "Additional Information",
		icon: faFileContract,
		color: pink,
		render: AdditionalInformation,
	},
	{
		id: "exports",
		name: "Export Information",
		icon: faFileExport,
		color: turquoise,
		render: ExportInformation,
	},
] satisfies FormSection[]
